import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import insightsPlusActive from '../../images/insight360/brand-catalyst-icon_white.png';
import exploreInactive from '../../images/insight360/explorer-icon_default.png';
import exploreActive from '../../images/insight360/explorer-icon_active.png';
import creatorInactive from '../../images/insight360/persona-creator-icon_beta-default.png';
import creatorActive from '../../images/insight360/persona-creator-icon_beta-active.png';
import reportsInactive from '../../images/insight360/report-icon_default.png';
import reportsActive from '../../images/insight360/report-icon_active.png';
import { PAGE_VISIT_BRAND_CATALYST } from '../../constants';
// import * as urls from '../../actions/urlTypes';

class Insight360ToolPalate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'EXPLORE',
      hoveredtab: 'EXPLORE',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.selectedTab !== nextProps.selectedTab) {
      this.setState({ selectedTab: nextProps.selectedTab });
    }
  }

  setTab = tabName => {
    if (tabName !== this.state.selectedTab) {
      this.props.trackerFn({ action: PAGE_VISIT_BRAND_CATALYST, subModule: tabName });
    }
    this.setState({
      selectedTab: tabName,
    });
    this.props.onselectedtab(tabName);
  };

  setMouseHoverTab = hovtab => {
    // console.log(hovtab);
    this.setState({
      hoveredtab: hovtab,
    });
  };

  render() {
    // console.log('ToolPallet -> ', this.state.selectedTab);
    return (
      <div className="insight360-width-455 minimize-tp float-left">
        <ul className="insight360_tool_bg">
          {/* <li className="insight360_tool_btn_explore">
                  <button onClick={() => this.setTab("EXPLORE")}
                  className="tool_img open_tool insight360_tool_btn"
                  onMouseOver={() => this.setMouseHoverTab("EXPLORE")}
                  onMouseOut={() => this.setMouseHoverTab("")}>
                      <img className="insight360_tool_img_explore"
                      src={this.state.selectedTab === 'EXPLORE' ||
                      this.state.hoveredtab === 'EXPLORE'
                      ? exploreactive: exploreinactive} alt="" />
                  </button>
          </li> */}
          <li className="insight360_tool_btn_explore">
            <button className="tool_img open_tool insight360_tool_btn deafult-cursor">
              <img
                className="insight360_tool_img_explore"
                src={insightsPlusActive}
                alt=""
              />
              {/* <p className="insight360_tool_btn_text_active color-white">INSIGHTS+</p> */}
            </button>
          </li>
          <li
            className={
              this.state.selectedTab === 'EXPLORE' ||
              this.state.hoveredtab === 'EXPLORE'
                ? 'insight360_tool_btn_others_active'
                : 'insight360_tool_btn_others'
            }
          >
            <button
              onClick={() => this.setTab('EXPLORE')}
              className="tool_img open_tool insight360_tool_btn_identity"
              onMouseOver={() => this.setMouseHoverTab('EXPLORE')}
              onMouseOut={() => this.setMouseHoverTab('')}
            >
              <img
                className="insight360_tool_img_identity"
                src={
                  this.state.selectedTab === 'EXPLORE' ||
                  this.state.hoveredtab === 'EXPLORE'
                    ? exploreActive
                    : exploreInactive
                }
                alt="EXPLORE"
              />
              <p
                className={
                  this.state.selectedTab === 'EXPLORE' ||
                  this.state.hoveredtab === 'EXPLORE'
                    ? 'insight360_tool_btn_text_active'
                    : 'insight360_tool_btn_text_default'
                }
              >
                EXPLORER
              </p>
            </button>
          </li>
          <li
            className={
              this.state.selectedTab === 'REPORTS' ||
              this.state.hoveredtab === 'REPORTS'
                ? 'insight360_tool_btn_others_active'
                : 'insight360_tool_btn_others'
            }
          >
            <button
              onClick={() => this.setTab('REPORTS')}
              className="tool_img open_tool insight360_tool_btn_activities"
              onMouseOver={() => this.setMouseHoverTab('REPORTS')}
              onMouseOut={() => this.setMouseHoverTab('')}
            >
              <img
                className="insight360_tool_img_activities"
                src={
                  this.state.selectedTab === 'REPORTS' ||
                  this.state.hoveredtab === 'REPORTS'
                    ? reportsActive
                    : reportsInactive
                }
                alt="REPORTS"
              />
              <p
                className={
                  this.state.selectedTab === 'REPORTS' ||
                  this.state.hoveredtab === 'REPORTS'
                    ? 'insight360_tool_btn_text_active'
                    : 'insight360_tool_btn_text_default'
                }
              >
                REPORTER
              </p>
            </button>
          </li>
          {this.props.studyInfo && !this.props.studyInfo.ss.includes('MRI') &&
          <li
            className={
              this.state.selectedTab === 'CREATOR' ||
              this.state.hoveredtab === 'CREATOR'
                ? 'insight360_tool_btn_others_active'
                : 'insight360_tool_btn_others'
            }
          >
            <button
              onClick={() => this.setTab('CREATOR')}
              className="tool_img open_tool
              insight360_tool_btn_activities insight360_tool_has_beta"
              onMouseOver={() => this.setMouseHoverTab('CREATOR')}
              onMouseOut={() => this.setMouseHoverTab('')}
            >
              <img
                className="insight360_tool_img_activities"
                src={
                  this.state.selectedTab === 'CREATOR' ||
                  this.state.hoveredtab === 'CREATOR'
                    ? creatorActive
                    : creatorInactive
                }
                alt="CREATOR"
              />
              <p
                className={
                  this.state.selectedTab === 'CREATOR' ||
                  this.state.hoveredtab === 'CREATOR'
                    ? 'insight360_tool_btn_text_active'
                    : 'insight360_tool_btn_text_default'
                }
              >
                CREATOR
              </p>
            </button>
          </li>
  }
          {/*
                    <li className="insight360_tool_btn_others" title="Coming Soon">
                        <button className="tool_img open_tool insight360_tool_btn_identity">
                            <img className="insight360_tool_img_identity" src={boardsInactive}
                             alt="MY BOARDS" />
                            <p className="insight360_tool_btn_text_default">MY BOARDS</p>
                        </button>
                    </li> */}
        </ul>
      </div>
    );
  }
}

Insight360ToolPalate.propTypes = {
  // loginResponse: PropTypes.shape({
  //   data: PropTypes.shape({
      // uid: PropTypes.number,
      // token: PropTypes.string,
  //   }),
  // }),
  onselectedtab: PropTypes.func,
  trackerFn: PropTypes.func,
};

// function mapStateToProps(state) {
//   return {
//     // loginResponse: state.login.loginResponse,
//   };
// }

// function mapDispatchToProps() {
//   return {};
// }

export default connect(
  null,
  null,
)(Insight360ToolPalate);
